<template>
  <div class="max-w-5xl mx-auto pb-5">
    <h2 class="text-2xl text-center text-white">Il Natale Solidale è sempre una buona idea.</h2>
    <section class="p-3 prose">
      <article class="py-5">
        <p class="">
          Il Market Solidale di Natale è il luogo di incontro per cittadini e aziende che vogliono rendere il Natale
          un’occasione per fare una scelta consapevole. Regali solidali, e-shop di Natale, donazioni libere e campagne
          di raccolta fondi: il portale offre la più ampia offerta di proposte di Natale di tutto il non profit italiano
          e tante possibilità di scelta e interazione.
        </p>
      </article>
      <article class="py-5">
        <img src="~/assets/images/icons/icona_firework.png" alt="sei un'azienda?" class="py-5 mx-auto">
        <h3 class="text-xl text-white pb-5">Idee Regalo Solidali</h3>
        <p>
          Sai già quali regali vorresti fare ai tuoi cari per Natale? La ricerca dei regali Solidali di Natale è il
          posto che fa per te! Sul Market Solidale di Natale puoi comparare le offerte delle organizzazioni non profit,
          catalogate per idee regalo: dal classico panettone solidale, ai gadget natalizi, fino ai prodotti
          tipici.<br /><br />
          Ma
          il market è il luogo perfetto anche per trovare ispirazione: esplora le idee regalo per categorie e trova
          nuove organizzazioni non profit da sostenere!
        </p>
      </article>
      <article class="py-5">
        <h3 class="text-xl text-white pb-5">Natale a km zero!</h3>
        <p>
          Vuoi sostenere local? Ci sono tante organizzazioni vicino a te che si occupano di ciò che ti sta più ti
          interessa. Con la ricerca geolocalizzata scopri nuove realtà attive nella tua zona, e come sostenerle in
          occasione del Natale.
        </p>
      </article>
      <article class="py-5">
        <img src="~/assets/images/icons/icona_heart.png" alt="sei un'azienda?" class="py-5 mx-auto">
        <h3 class="text-xl text-white pb-5">Parti da ciò che ti sta a cuore</h3>
        <p>
          Questo Natale fare un regalo solidale è molto più di un semplice dono per chi ami: è un gesto d’amore per il
          futuro di tutti. Ambiente, salute, cooperazione internazionale, e tantissime altre urgenti missioni. Le
          organizzazioni non profit si prendono cura di ciò che ti sta a cuore, tutto l’anno. Sul Market Solidale di
          Natale scegli la causa che vuoi sostenere e scopri tutti gli enti non profit che stanno operando in
          quell’ambito. Sostenerli con una donazione è il miglior investimento sul futuro che tu possa fare, oggi.
        </p>
      </article>
    </section>

  </div>
</template>

<script setup lang="ts">
import { definePageMeta } from "#imports";

const showActions = inject('showActions')
// Cambia il valore per questa pagina
showActions.value = false
definePageMeta({
  layout: 'dark'
})

useSeoMeta({
  title: 'Come funziona il Market Solidale',
  description: 'Il Market Solidale di Natale è il luogo di incontro per cittadini e aziende che vogliono rendere il Natale un’occasione per fare una scelta consapevole. Regali solidali, e-shop di Natale, donazioni libere e campagne di raccolta fondi: il portale offre la più ampia offerta di proposte di Natale di tutto il non profit italiano e tante possibilità di scelta e interazione.',
  image: 'https://onp.app/seo/natale.jpg'
})
</script>